import { TransferKey } from "antd/es/transfer/interface";
import { AxiosInstance } from "axios";

export const LuckyManagementService = (axiosInstance: AxiosInstance) => {
  const urlBaseApiLucky = "api/lucky";
  const urlBaseApiUserOfLucky = "api/useroflucky";
  const urlBaseApiCheckin = "api/checkin";
  const urlBaseApiListUsers = "api/user";
  const urlBaseApiWinder = "api/lucky-winner";
  const urlBaseApiUserImport = "api/user-imported";
  return {
    findAll: async () => {
      return await axiosInstance
        .get(`${urlBaseApiLucky}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    createLucky: async (dataCreate: any) => {
      return await axiosInstance
        .post(`${urlBaseApiLucky}`, dataCreate)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },

    findluckofusersById: async (id?: string) => {
      return await axiosInstance
        .get(`${urlBaseApiUserOfLucky}/many/${id}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    findUsers: async () => {
      return await axiosInstance
        .get(`${urlBaseApiListUsers}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    findUsersOptionByAgenda: async (agendaid: string, status?: boolean) => {
      const params = { status: status };
      return await axiosInstance
        .get(`${urlBaseApiListUsers}/users-option/${agendaid}`, { params })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    setUsertoLucky: async (luckyId?: string, userId?: TransferKey[]) => {
      return await axiosInstance
        .post(`${urlBaseApiUserOfLucky}/many`, {
          data: { luckyId: luckyId, userId: userId },
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    findWinnerById: async (id?: string) => {
      return await axiosInstance
        .get(`${urlBaseApiWinder}/userwinner/${id}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    createUsersFromImport: async (dataCreate: {
      agendaId: string;
      luckyId: number;
    }) => {
      return await axiosInstance
        .post(`${urlBaseApiUserImport}/createfrom/new`, { data: dataCreate })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return null;
        });
    },
  };
};
